import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, formValueSelector, reduxForm } from 'redux-form';
import messages from '../../locale/messages';
import validateStep3 from './validateStep3';

import Slider from 'rc-slider';
import rcSliderStyles from 'rc-slider/assets/index.css';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import updateStep3 from './updateStep3';
import stepClockIllustration from '/public/SiteImages/step-clock.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';


const formatHour = (value) => {
  let hour = parseInt(value, 10);
  if (isNaN(hour)) return '00:00';
  let h = hour > 23 ? hour - 24 : hour;
  return `${String(h).padStart(2, '0')}:00`;
};

class TimeRangeSlider extends Component {

  static propTypes = {
    startField: PropTypes.string.isRequired,
    endField: PropTypes.string.isRequired,
    fromLabel: PropTypes.string,
    toLabel: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    startValue: PropTypes.any,
    endValue: PropTypes.any,
    change: PropTypes.any.isRequired
  };

  static defaultProps = {
    min: 8,
    max: 26
  };

  handleChange = (values) => {
    const { change, startField, endField } = this.props;
    if (values && values.length === 2 && !isNaN(values[0]) && !isNaN(values[1])) {
      change('ListPlaceStep3', startField, String(values[0]));
      change('ListPlaceStep3', endField, String(values[1]));
    }
  }

  componentDidMount() {
    const { change, startField, endField, min, max, startValue, endValue } = this.props;
    if (isNaN(parseInt(startValue, 10))) change('ListPlaceStep3', startField, String(min));
    if (isNaN(parseInt(endValue, 10))) change('ListPlaceStep3', endField, String(max));
  }

  render() {
    const { min, max, fromLabel, toLabel, startValue, endValue } = this.props;

    let start = parseInt(startValue, 10);
    let end = parseInt(endValue, 10);
    if (isNaN(start)) start = min;
    if (isNaN(end)) end = max;

    const value = [Math.min(start, end), Math.max(start, end)];

    return (
      <div className={s.timeRangeWrap}>
        <div className={s.timeRangeLabels}>
          <span className={s.timeRangeLabel}>
            <span className={s.timeRangeLabelText}>{fromLabel}</span>
            <span className={s.timeRangeValue}>{formatHour(value[0])}</span>
          </span>
          <span className={s.timeRangeLabel}>
            <span className={s.timeRangeValue}>{formatHour(value[1])}</span>
            <span className={s.timeRangeLabelText}>{toLabel}</span>
          </span>
        </div>
        <Slider
          range
          min={min}
          max={max}
          step={1}
          allowCross={false}
          defaultValue={value}
          value={value}
          onChange={this.handleChange}
        />
        <div className={s.timeRangeScale}>
          <span>{formatHour(min)}</span>
          <span>{formatHour(max)}</span>
        </div>
      </div>
    );
  }
}

const timeRangeSelector = formValueSelector('ListPlaceStep3');

const mapTimeRangeState = (state, ownProps) => ({
  startValue: timeRangeSelector(state, ownProps.startField),
  endValue: timeRangeSelector(state, ownProps.endField)
});

const mapTimeRangeDispatch = {
  change
};

TimeRangeSlider = connect(mapTimeRangeState, mapTimeRangeDispatch)(withStyles(rcSliderStyles)(TimeRangeSlider));


class AdvanceNotice extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      bookingNoticeTime: [],
      policyContent: ''
    }
    this.handleCancellation = this.handleCancellation.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    const { cancellationPolicies, cancelPolicy } = this.props;
    if (cancellationPolicies && cancellationPolicies.length > 0) {
      let itemListData = cancelPolicy ? cancellationPolicies.filter(policy => { if (policy.id == cancelPolicy) return policy; }) : cancellationPolicies[0];
      this.setState({
        policyContent: itemListData && itemListData[0] ? itemListData[0].policyContent : itemListData.policyContent
      });
    }
    if (listingFields != undefined) {
      this.setState({
        bookingNoticeTime: listingFields.bookingNoticeTime,
      });
    }
  }

  componentDidMount() {
    const { valid } = this.props;
    const { cancellationPolicies, cancelPolicy } = this.props;
    if (cancellationPolicies && cancellationPolicies.length > 0) {
      let itemListData = cancelPolicy ? cancellationPolicies.filter(policy => { if (policy.id == cancelPolicy) return policy; }) : cancellationPolicies[0];
      this.setState({
        policyContent: itemListData && itemListData[0] ? itemListData[0].policyContent : itemListData.policyContent
      });
    }
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;
    const { cancellationPolicies, cancelPolicy } = nextProps;
    if (cancellationPolicies && cancellationPolicies.length > 0) {
      let itemListData = cancelPolicy ? cancellationPolicies.filter(policy => { if (policy.id == cancelPolicy) return policy; }) : cancellationPolicies[0];
      this.setState({
        policyContent: itemListData && itemListData[0] ? itemListData[0].policyContent : itemListData.policyContent
      });
    }
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }

    if (listingFields != undefined) {
      this.setState({
        bookingNoticeTime: listingFields.bookingNoticeTime,
      });
    }
  }


  handleCancellation() {
    const { cancellationPolicies, cancelPolicy } = this.props;
    let itemListData = cancellationPolicies && cancellationPolicies.length > 0 ? cancellationPolicies.filter(policy => policy.id == cancelPolicy) : [];
    this.setState({
      policyContent: itemListData && itemListData[0] ? itemListData[0].policyContent : ''
    });
  }

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step } = this.props;
    const { bookingNoticeTime, policyContent } = this.state;
    const { formatMessage } = this.props.intl;

    let cancellationPolicyValue = [
      { value: '1', label: formatMessage(messages.flexible) },
      { value: '2', label: formatMessage(messages.moderate) },
      { value: '3', label: formatMessage(messages.strict) }
    ]

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Por último, \n`}
            highlightText="establezcamos horarios"
            subtitle=""
            iconImg={stepClockIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.pricingStepCard)}>
              <div className={s.landingMainContent}>
                <br />
                <p className={cx(s.amenitiesSpacesLabel)}>Coloca las reglas básicas de horario de Check-in (ingreso) {`\n`} y de Check-out (salida) para que tus huespedes lo conozcan.</p>
                <h3 className={s.timeCardTitle}>
                  <FormattedMessage {...messages.advanceNoticeCheckInTitle} />
                </h3>
                <div className={s.timeCard}>
                  <TimeRangeSlider
                    startField="checkInStart"
                    endField="checkInEnd"
                    fromLabel={formatMessage(messages.advanceNoticeFrom)}
                    toLabel={formatMessage(messages.advanceNoticeTo)}
                    min={8}
                    max={26}
                  />
                </div>

                <h3 className={s.timeCardTitle}>
                  <FormattedMessage {...messages.advanceNoticeCheckOutTitle} />
                </h3>
                <div className={s.timeCard}>
                  <TimeRangeSlider
                    startField="checkOutStart"
                    endField="checkOutFixed"
                    fromLabel={formatMessage(messages.advanceNoticeFrom)}
                    toLabel={formatMessage(messages.advanceNoticeTo)}
                    min={9}
                    max={27}
                  />
                </div>

                {/* <FormGroup className={cx(s.formGroup, s.spaceTop4)}>
                  <Field name="cancellationPolicy"
                    component={SelectFieldComponent}
                    label={formatMessage(messages.chooseCancellationPolicy)}
                    labelClass={cx(s.landingLabel)}
                    inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                    onChange={() => this.handleCancellation()}
                    options={cancellationPolicyValue}
                  >
                  </Field>
                </FormGroup>
                <div className={s.tipCommonCss}>
                  <img src={toolTipIcon} />
                  <span className={cx(s.commonTipCsss)}>{policyContent}</span>
                </div> */}
              </div>
              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={"calendar"}
                previousPagePath={"discount"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

AdvanceNotice = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(AdvanceNotice);

const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

const mapState = (state) => ({
  cancelPolicy: selector(state, 'cancellationPolicy'),
  listingFields: state.listingFields.data,
  existingList: state.location.isExistingList,
  cancellationPolicies: state.location.cancellationPolicies,
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AdvanceNotice)));